<template>
    <div>
        <label class="label" v-if="showLabel && label">{{ label }}</label>
        <component
            aria-role="menu"
            class="dropdown dropdown-listed dropdown-workspaceuser"
            :class="{ 'is-disabled': iniDisabled }"
            :mobile-modal="false"
            :position="position"
            @active-change="addFocus"
            :disabled="iniDisabled"
            :is="iniDisabled ? 'div' : 'bDropdown'">
            <a :class="['button is-cancel is-outlined is-trigger', condensed ? 'is-icon' : 'pl5-xs']" slot="trigger">
                <loader v-if="isFetching && !selectedValue" text=" " />
                <template v-if="selectedValue">
                    <UserAvatar
                        :firstName="selectedValue.profile.firstName"
                        :lastName="selectedValue.profile.lastName"
                        :url="selectedValue.profile.avatarUrl"
                        :condensed="condensed"
                        class="sm m0" />
                    <template v-if="condensed">
                        <span class="icon" v-if="!iniDisabled">
                            <font-awesome-icon :icon="['fas', 'angle-down']" />
                        </span>
                    </template>
                    <template v-else>
                        <span
                            class="button is-detailMenu icon on-hover"
                            @click.prevent="showDetailClick(value)"
                            v-if="!hideDetail">
                            <font-awesome-icon :icon="['fas', 'eye']" />
                        </span>
                        <span class="icon m0" @click.prevent="clear" v-if="!iniDisabled">
                            <font-awesome-icon :icon="['fas', 'times']" />
                        </span>
                    </template>
                </template>
                <template v-else>
                    <div class="avatar sm m0 blank">
                        <span class="img">
                            <font-awesome-icon :icon="['fas', 'user']" />
                        </span>
                        <div class="meta" v-if="!condensed">
                            <div class="name fade-50">
                                {{ showLabel && !iniDisabled ? $t('chooseUser') : '' }}
                            </div>
                        </div>
                    </div>
                    <span class="icon" v-if="!iniDisabled"> <font-awesome-icon :icon="['fas', 'angle-down']" /> </span>
                </template>
            </a>
            <template v-if="!iniDisabled">
                <template v-if="showCurrentUser">
                    <b-dropdown-item aria-role="menu-item" has-link>
                        <a href="javascript:void(0)" @click.prevent="onClick(currentUser)">
                            <UserAvatar
                                :firstName="currentUser.profile.firstName"
                                :lastName="currentUser.profile.lastName"
                                :url="currentUser.profile.avatarUrl"
                                :condensed="false"
                                class="sm" />
                        </a>
                    </b-dropdown-item>
                    <hr class="dropdown-divider" aria-role="menuitem" />
                </template>
                <template v-if="showSearch">
                    <b-dropdown-item aria-role="menu-item" custom>
                        <textInput type="SEARCH" v-model="searchTerm" @input="doSearch" ref="search" />
                    </b-dropdown-item>

                    <div class="head">
                        <span v-if="count" class="mr5-xs">{{ count }}</span>
                        {{ $t('searchResults') }}
                    </div>
                </template>
                <b-dropdown-item aria-role="menu-item" v-if="isLoading" class="is-info">
                    <loader :text="$t('searching')" />
                </b-dropdown-item>
                <b-dropdown-item
                    aria-role="menu-item"
                    v-else-if="data && data.length == 0 && !isLoading"
                    class="is-info"
                    >{{ $t('noUsersFound') }}</b-dropdown-item
                >
                <template v-else-if="data && data.length > 0">
                    <b-dropdown-item aria-role="menu-item" :key="index" v-for="(item, index) in data" has-link>
                        <a href="javascript:void(0)" @click.prevent="onClick(item)">
                            <UserAvatar
                                :firstName="item.profile.firstName"
                                :lastName="item.profile.lastName"
                                :url="item.profile.avatarUrl"
                                :condensed="false"
                                class="sm" />
                        </a>
                    </b-dropdown-item>
                </template>
                <pagination :count="count" v-model="pagination" :hidePerPage="true"></pagination>

                <template v-if="selectedValue">
                    <hr class="dropdown-divider" aria-role="menuitem" />
                    <b-dropdown-item aria-role="menu-item" @click="clear">
                        <span class="icon">
                            <font-awesome-icon :icon="['fas', 'times']" />
                        </span>
                        <span> {{ $t('clearSelection') }} </span>
                    </b-dropdown-item>
                </template>
            </template>
        </component>
    </div>
</template>
<script>
import paginationMixin from './../mixins/pagination.js';
import { stringToHslColor } from './../mixins/helpers.js';
import UserAvatar from './UserAvatar.vue';

import { getWorkspaceUsers, getWorkspaceUser, getClientWorkspaceUsers } from './../services/workspace.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAngleDown, faEye, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';

library.add(faAngleDown);
library.add(faEye);
library.add(faTimes);
library.add(faUser);

export default {
    name: 'WorkspaceUserSelect',
    components: { UserAvatar, FontAwesomeIcon },
    props: {
        value: [Object, Array],
        userId: [String], //optional, if used the user is fetched
        label: { type: String },
        showLabel: { type: Boolean, default: true },
        iniDisabled: { type: Boolean, default: false },
        hideDetail: { type: Boolean, default: false },
        showCurrentUser: { type: Boolean, default: true },
        clientUsersOnly: { type: Boolean, default: false },
        condensed: { type: Boolean, default: false },
        position: { type: String },
    },
    mixins: [paginationMixin],
    data() {
        return {
            selectedValue: null,
            data: null,
            isLoading: false,
            isFetching: false,
            searchTerm: '',
            isSearching: false,
            recentItems: [],
        };
    },
    computed: {
        currentUser() {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser) {
                currentUser.id = currentUser.Id;
            }
            return currentUser;
        },
        showSearch() {
            return this.count - this.perPage > 0;
        },
    },
    watch: {
        value() {
            this.handleValue();
        },
        searchTerm() {
            if (!this.searchTerm) {
                this.clearSearch();
            } else {
                this.doSearch();
            }
        },
        userId(newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                this.handleUserId();
            }
        },
    },
    created() {
        this.handleValue();
        this.handleUserId();
    },
    methods: {
        stringToHslColor,
        addFocus(active) {
            if (active) {
                if (!this.data) {
                    //fetch data is not yet fetched
                    this.fetchData();
                }
                if (this.$refs.search) {
                    this.$nextTick(() => {
                        this.$refs.search.$el.querySelector('input').focus();
                    });
                }
            }
        },
        handleValue() {
            this.selectedValue = this.value;
        },
        async handleUserId() {
            if (this.userId) {
                this.isFetching = true;
                var user = await getWorkspaceUser({ userId: this.userId })
                    .then((response) => {
                        return response.data;
                    })
                    .catch((e) => {});
                this.selectedValue = user;
                this.$emit('input', user);
            }
            this.isFetching = false;
        },
        paginateChange(newPagination) {
            this.fetchData(newPagination);
        },
        async fetchData(pagination = this.pagination) {
            this.isLoading = true;
            let payload = {
                page: pagination.currentPage,
                itemsPerPage: 5,
                searchTerm: this.searchTerm,
            };

            if (this.clientUsersOnly) {
                await getClientWorkspaceUsers(payload)
                    .then((response) => {
                        this.data = response.data;
                        this.count = response.count;
                    })
                    .catch((e) => {});
            } else {
                await getWorkspaceUsers(payload)
                    .then((response) => {
                        this.data = response.data;
                        this.count = response.count;
                    })
                    .catch((e) => {});
            }
            //remove currentUser from list if already show at top
            if (this.showCurrentUser) {
                this.data = this.data.filter((user) => {
                    return user.id != this.currentUser.Id;
                });
                this.count -= 1;
            }

            this.isLoading = false;
        },
        showDetailClick(item) {
            document.dispatchEvent(
                new CustomEvent('showDetailObject', {
                    detail: {
                        id: item.id,
                        type: 'USER',
                        meta: { title: item.profile.firstName },
                    },
                })
            );
        },
        clear(e) {
            this.selectedValue = null;
            this.$emit('input', null);
            if (e) {
                e.stopPropagation();
            }
        },
        onClick(item) {
            this.selectedValue = item;
            this.$emit('input', item);
            this.clearSearch();
            /*if (item) {
                document.dispatchEvent(
                    new CustomEvent('showDetailObject', {
                        detail: {
                            id: item.id,
                            type: 'USER',
                            meta: { title: item.profile.firstName },
                            showMenu: false,
                        },
                    })
                );
            }*/
        },
        doSearch() {
            if (this.searchTerm && this.searchTerm.length >= 3) {
                this.currentPage = 0;
                this.fetchData();
            }
        },
        clearSearch() {
            this.searchTerm = '';
            this.currentPage = 0;
            this.fetchData();
        },
    },
    i18n: {
        messages: {
            en: {
                searchResults: 'Search results',
                searching: 'Searching',
                noUsersFound: 'No users found',
                chooseUser: 'Choose user',
                none: 'None',
                clearSelection: 'Clear selection',
            },
            fr: {
                searchResults: 'Résultats de recherche',
                searching: 'Recherche en cours',
                noUsersFound: 'Aucun projet trouvé',
                recentProjects: 'Projets récents',
                chooseProject: 'Choisir un projet',
                clearSelection: 'Effacer la sélection',
            },
            nl: {
                searchResults: 'Zoekresultaten',
                searching: 'Bezig met zoeken',
                noUsersFound: 'Geen projecten gevonden',
                recentProjects: 'Recente projecten',
                chooseProject: 'Kies een project',
                clearSelection: 'Selectie wissen',
            },
        },
    },
};
</script>

<style lang="scss">
html body .dropdown.dropdown-workspaceuser {
    &.dropdown.is-disabled {
        opacity: 1;
        cursor: default;
        .button.is-trigger.is-cancel {
            border-color: transparent;
            background-color: transparent;
            &:hover {
                color: var(--text-color);
                border-color: transparent;
                //border-color: var(--background-color-darker);
                background-color: transparent;
                cursor: default;
            }
        }
    }

    .button.is-trigger.is-cancel {
        text-transform: none;
        background-color: #fff;
        text-transform: none;
        color: var(--text-color);

        span.on-hover {
            opacity: 0;
        }
        &:hover {
            span.on-hover {
                cursor: pointer;
                opacity: 1;
            }
        }
    }

    .button.is-detailMenu {
        width: 25px;
        height: 25px;
    }

    .avatar.blank {
        span.img {
            background-color: var(--background-color-darker);
            color: var(--txt-color);
        }
    }
}
</style>
